import { useEffect, useState } from 'react';
import { HelpCircle, Download, Eye, ExternalLink } from 'lucide-react';
import API from '../api';

export default function Help() {
  const [manuals, setManuals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    API.get('/api/manuals')
      .then(r => setManuals(r.data))
      .catch(e => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  const formatDate = (iso) => {
    if (!iso) return '-';
    try {
      const d = new Date(iso);
      return d.toLocaleDateString('th-TH', { day: '2-digit', month: 'short', year: 'numeric' });
    } catch {
      return '-';
    }
  };

  const cardStyle = { background: '#fff', border: '1px solid #e2e8f0', borderRadius: 12, padding: 20, display: 'flex', alignItems: 'center', gap: 16 };
  const iconBoxStyle = { width: 56, height: 56, borderRadius: 12, background: '#f0f9ff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 32, flexShrink: 0 };
  const btnPrimary = { display: 'inline-flex', alignItems: 'center', gap: 6, padding: '10px 14px', background: '#0ea5e9', color: '#fff', borderRadius: 8, fontSize: 13, fontWeight: 600, textDecoration: 'none', cursor: 'pointer' };
  const btnSecondary = { display: 'inline-flex', alignItems: 'center', gap: 6, padding: '10px 14px', background: '#f1f5f9', color: '#475569', border: '1px solid #e2e8f0', borderRadius: 8, fontSize: 13, fontWeight: 600, textDecoration: 'none', cursor: 'pointer' };

  return (
    <div style={{ padding: 24, maxWidth: 900, margin: '0 auto' }}>
      <div style={{ marginBottom: 32 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8 }}>
          <HelpCircle size={32} color="#0ea5e9" />
          <h1 style={{ fontSize: 28, fontWeight: 700, color: '#0e2a59', margin: 0 }}>ศูนย์ช่วยเหลือ</h1>
        </div>
        <p style={{ color: '#64748b', fontSize: 15, margin: 0 }}>คู่มือและเอกสารสำหรับใช้งานระบบ AUTO CHATS</p>
      </div>

      <div style={{ marginBottom: 32 }}>
        <h2 style={{ fontSize: 18, fontWeight: 700, color: '#1e293b', marginBottom: 16 }}>📖 คู่มือเอกสาร</h2>

        {loading ? (
          <div style={{ padding: 40, textAlign: 'center', color: '#94a3b8' }}>กำลังโหลด...</div>
        ) : error ? (
          <div style={{ padding: 16, background: '#fef2f2', color: '#dc2626', borderRadius: 8, border: '1px solid #fecaca' }}>
            ไม่สามารถโหลดรายการคู่มือได้: {error}
          </div>
        ) : manuals.length === 0 ? (
          <div style={{ padding: 40, textAlign: 'center', color: '#94a3b8', background: '#f8fafc', borderRadius: 12, border: '1px dashed #cbd5e1' }}>ยังไม่มีคู่มือ</div>
        ) : (
          <div style={{ display: 'grid', gap: 12 }}>
            {manuals.map(m => (
              <div key={m.id} style={cardStyle}>
                <div style={iconBoxStyle}>{m.icon || '📄'}</div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <h3 style={{ fontSize: 16, fontWeight: 700, color: '#0e2a59', margin: '0 0 4px 0' }}>{m.title}</h3>
                  <p style={{ fontSize: 13, color: '#64748b', margin: '0 0 8px 0' }}>{m.description}</p>
                  <div style={{ display: 'flex', gap: 12, fontSize: 12, color: '#94a3b8', flexWrap: 'wrap' }}>
                    <span>📄 {m.pages} หน้า</span>
                    <span>•</span>
                    <span>📦 {m.size_human}</span>
                    <span>•</span>
                    <span>{m.version}</span>
                    <span>•</span>
                    <span>อัพเดต {formatDate(m.updated_at)}</span>
                  </div>
                </div>
                <div style={{ display: 'flex', gap: 8, flexShrink: 0 }}>
                  <a href={m.url} target="_blank" rel="noopener noreferrer" style={btnPrimary}><Eye size={16} /> เปิดดู</a>
                  <a href={m.url} download style={btnSecondary}><Download size={16} /> ดาวน์โหลด</a>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <div style={{ marginTop: 32, padding: 16, background: '#f8fafc', borderRadius: 12, fontSize: 13, color: '#64748b', display: 'flex', alignItems: 'center', gap: 12 }}>
        <ExternalLink size={16} />
        <span>หากมีคำถามหรือพบปัญหา ติดต่อ admin ได้ตามช่องทางที่ทีมงานแจ้งไว้</span>
      </div>
    </div>
  );
}
